import db from "astrid-firebase/src/db";
import useDocumentData from "astrid-firestore/src/hooks/useDocumentData";

import Actions from "../../../ui/components/Actions/Actions";
import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import CostInfo from "./components/CostInfo";

export default function CostView({ id }) {
	const [cost, loading, error] = useDocumentData(id && db.collection("costs").doc(id));

	return (
		<LoadingContext data={cost} loading={loading} error={error}>
			{cost && (
				<>
					<CostInfo cost={cost} />

					<Actions data={cost}>
						<Actions.DeletionAction right="costs.delete" />
					</Actions>
				</>
			)}
		</LoadingContext>
	);
}
